import {
  Injectable
} from '@angular/core';
import { getApp } from '@angular/fire/app';
import { getFunctions, httpsCallable } from '@angular/fire/functions';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  Observable,
  Observer
} from 'rxjs';

import { regionConst } from '../dal/databaseConstants';
import { lastValueFrom } from 'rxjs';
import { OpenFoodFacts } from 'app/models/open-food-facts';


@Injectable({
  providedIn: 'root'
})
export class OpenFoodFactsExternalService {

  constructor(private http: HttpClient) { }

  async getProduct(barcode: string, email: string): Promise<OpenFoodFacts | null> {
    const functions = getFunctions(getApp());
    const getOpenFoodFactsProductFn = httpsCallable(functions, 'getOpenFoodFactsProduct');

    try {
      const result = await getOpenFoodFactsProductFn({ barcode, email }) as any;
      return result.data;
    } catch (error: any) {
      console.error('Error fetching product from OpenFoodFacts:', error);

      // Check whether it's a 404 error (product not found)
      if (error.code === 'not-found' || error.message?.includes('404')) {
        return null;
      }

      throw error;
    }
  }
}
